/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import styled, { css } from 'styled-components'
import { VerticalStyledScrollBar, theme } from '~/styles'

interface ITableStyle {
  scroll?: boolean
  styleScroll?: boolean
}

export const TableContainerStyle = styled.div<{ minHeight?: string }>`
  position: relative;
  min-height: ${({ minHeight }) => minHeight || '300px'};
  flex: 1 1 auto;
  width: 100%;
  height: 100%;

  display: flex;
  flex-flow: column;
`

export const ErrorStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translate(-50%, 0);

  span {
    color: ${props => props.theme.colors.color6b7786};
    font-size: 14px;

    p {
      text-align: left;
      font-size: 14px;
      font-weight: 600;
      color: ${props => props.theme.colors.color6b7786};
    }
  }
`

export const LoadingContainer = styled.div`
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(255, 255, 255, 0.7);
`

export const TableStyle = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))<ITableStyle>`
  position: relative;
  height: min-content;
  box-sizing: border-box;
  overflow-x: visible;

  ${({ styleScroll }) =>
    styleScroll
      ? css`
          padding: 8px 0 8px 8px;
          box-shadow: 15px 0px 20px -25px rgb(0 0 0 / 30%);
          z-index: 10;
        `
      : css`
          width: 100%;
        `}

  ${({ scroll }) =>
    scroll &&
    css`
      width: 100%;
      padding: 8px 8px 8px 0px;
      border-radius: 0 4px 4px 0;
      overflow-x: auto;
      overflow-y: hidden;
    `}

  ${VerticalStyledScrollBar}
`
export const ContainerStyle = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 85vh;
  max-height: 100%;
  background-color: ${theme.colors.colorf3f5f9};
  box-sizing: border-box;
  padding: 50px;
`
